const IconKPIs = ({ className }) => {
    return (
        <svg
            xmlns='http://www.w3.org/2000/svg'
            width='34'
            height='32'
            viewBox='0 0 34 32'
            fill='none'
            className={className}
        >
            <rect x='1.94141' y='16.9375' width='7.52941' height='13.125' rx='1' stroke='white' strokeWidth='2' />
            <rect x='13.2354' y='1.9375' width='7.52941' height='28.125' rx='1' stroke='white' strokeWidth='2' />
            <rect x='24.5293' y='11.3125' width='7.52941' height='18.75' rx='1' stroke='white' strokeWidth='2' />
        </svg>
    );
};

export default IconKPIs;
